import { platformFeatures } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为什么选择 <span className="text-primary-600">鼎盛平台</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            六大核心优势，为您打造安全、稳定、高效的服务体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {platformFeatures.map((feature, index) => (
            <div
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200/50 hover:bg-background-100/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}